angular.module('Directives')
.directive('portfolioBuilderPromoBanner', function () {
  return {
    restrict: 'E',
    templateUrl: 'portfolio-builder-promo-banner.html',
  };
});